/**
 * Yup transform helper — normalises empty or whitespace-only strings to null.
 * Usage: yup.string().transform(makeEmptyStringNull).nullable()
 */
export const makeEmptyStringNull = (value: string): string | null => {
  if (typeof value === 'string' && value.trim() === '') return null;
  return value;
};
